const TRILLION = 1e12;
const BILLION = 1e9;
const MILLION = 1e6;
const THOUSAND = 1e3;
const LARGE_NUMBER_THRESHOLD = 1e15;
const COST_FORMAT_DECIMALS = 5;
// Truncates (does not round) to `decimals` places using string slicing to avoid float precision issues.
function truncateToDecimals(value, decimals) {
    const str = value.toString();
    const dot = str.indexOf('.');
    if (dot === -1)
        return value;
    return parseFloat(str.slice(0, dot + decimals + 1));
}
const formatNumber = (value, decimals = COST_FORMAT_DECIMALS) => Number(truncateToDecimals(value, decimals).toFixed(decimals)).toString();
/**
 * Formats the cost to a human readable format.
 * @param cost - The cost to format.
 * @returns The formatted cost.
 * @example
 * formatCost(1000) => '1k'
 * formatCost(1000000) => '1m'
 * formatCost(1000000000) => '1b'
 * formatCost(1000000000000) => '1t'
 * formatCost(0.123456) => '0.12345'
 */
export function formatCost(cost) {
    if (!cost || isNaN(cost) || !Number.isFinite(cost)) {
        return '0';
    }
    const abs = Math.abs(cost);
    if (abs >= LARGE_NUMBER_THRESHOLD) {
        return cost.toExponential(COST_FORMAT_DECIMALS);
    }
    if (abs > 0 && abs < 0.00001) {
        return '0';
    }
    if (abs >= TRILLION) {
        return `${formatNumber(cost / TRILLION)}t`;
    }
    if (abs >= BILLION) {
        return `${formatNumber(cost / BILLION)}b`;
    }
    if (abs >= MILLION) {
        return `${formatNumber(cost / MILLION)}m`;
    }
    if (abs >= THOUSAND) {
        return `${formatNumber(cost / THOUSAND)}k`;
    }
    return formatNumber(cost);
}
